import { Trans } from "@lingui/macro";
import { UiBox, UiTypography } from "@smp/ui";
import { textCurrencySymbolGet } from "@smp/utils";
import { FC } from "react";

import { useEpBillingFeature } from "@/hooks/use_ep_billing_feature";
import { useHumanizer } from "@/hooks/use_humanizer";

import { IProductDescriptionProps } from "../../product_description";

export interface IDetailsProps {
  product: IProductDescriptionProps["product"];
  isOneYearPeriodPlanProduct: boolean;
  monthlyPrice: number | undefined;
  productName?: string;
}

export const Details: FC<IDetailsProps> = ({
  product,
  isOneYearPeriodPlanProduct,
  monthlyPrice,
  productName,
}) => {
  const { humanizeBillingPlanId, humanizeFeatureName } = useHumanizer();

  const { feature } = useEpBillingFeature({
    req: {
      path: {
        id: product.type === "feature-subscription" ? product.feature : 0,
      },
    },
    useQueryOptions: {
      enabled: product.type === "feature-subscription",
    },
  });

  return (
    <UiBox display="flex" flexDirection="row" mb={1}>
      <UiBox flexGrow={1}>
        <UiTypography variant="h5">
          {(() => {
            if (productName) {
              return productName;
            } else if (product.type === "plan-product") {
              return humanizeBillingPlanId(product.plan.id);
            } else if (product.type === "feature-subscription") {
              return feature?.name ? humanizeFeatureName(feature.name) : null;
            } else if (product.type === "token") {
              return <Trans>Credits for X (Twitter)</Trans>;
            } else {
              return <Trans>Post package</Trans>;
            }
          })()}
        </UiTypography>
      </UiBox>
      <UiBox display="flex" flexGrow={0} textAlign="right">
        {isOneYearPeriodPlanProduct && monthlyPrice && (
          <>
            <UiTypography color="textSecondary" noWrap variant="h5" mr={1}>
              <s>{(monthlyPrice * 12).toFixed(0)}</s>
            </UiTypography>
          </>
        )}
        <UiTypography noWrap variant="h5">
          {product.price} {textCurrencySymbolGet(product.currency)}
        </UiTypography>
      </UiBox>
    </UiBox>
  );
};
